import styled from "styled-components";

export const NextScheduledActionsStyle = styled.div`
  padding: 0 20px;
  margin-bottom: 40px;
  
  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 16px;
  }
  
  .section-title {
    font-size: 28px;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
  }
  
  .timeframe-selector {
    position: relative;

    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background: rgba(255, 255, 255, 0.06);
      border: 1px solid rgba(255, 255, 255, 0.12);
      border-radius: 10px;
      color: #ffffff;
      padding: 8px 36px 8px 14px; /* extra right padding for the caret */
      font-size: 14px;
      cursor: pointer;
      transition: all 0.2s ease;
      min-width: 96px;

  /* caret is rendered by the container (::after) to avoid flicker during select hover/focus transitions */

      &:hover {
        background: rgba(255, 255, 255, 0.12);
        border-color: rgba(255, 255, 255, 0.22);
      }

      &:focus {
        outline: none;
        border-color: #007AFE;
      }

      /* Hide IE's dropdown arrow */
      &::-ms-expand {
        display: none;
      }

      option {
        background: #1a1f2e;
        color: #ffffff;
      }
    }

    /* Use a pseudo-element for the caret so it doesn't get repainted/hidden when the select background transitions */
    &::after {
      content: "";
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      width: 12px;
      height: 8px;
      pointer-events: none;
      background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23FFFFFF' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round' fill='none'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 12px 8px;
      opacity: 1; /* keep visible always */
    }
  }
  
  .tabs-container {
    display: flex;
    gap: 8px;
    margin-bottom: 24px;
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);
    padding-bottom: 0;
  }
  
  .tab {
    background: transparent;
    border: none;
    color: #b8b8b8;
    font-size: 16px;
    font-weight: 500;
    padding: 12px 24px;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    border-bottom: 3px solid transparent;
    
    &:hover {
      color: #ffffff;
    }
    
    &.active {
      color: #ffffff;
      border-bottom-color: #007AFE;
    }
  }
  
  .content-container {
    min-height: 200px;
  }
  
  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 300px 0;
    color: #b8b8b8;
    font-size: 16px;
    
    &:before {
      content: "";
      width: 24px;
      height: 24px;
      margin-right: 12px;
      border: 3px solid rgba(255, 255, 255, 0.1);
      border-top-color: #007AFE;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }
  }
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
  
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
    color: #b8b8b8;
    
    .empty-icon {
      font-size: 48px;
      margin-bottom: 16px;
      opacity: 0.5;
    }
    
    .empty-title {
      font-size: 18px;
      font-weight: 600;
      color: #ffffff;
      margin-bottom: 8px;
    }
    
    .empty-subtitle {
      font-size: 14px;
      color: #b8b8b8;
    }
  }
  
  .error-message {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 20px;
    margin: 20px 0;
    background: rgba(239, 68, 68, 0.1);
    border: 1px solid rgba(239, 68, 68, 0.3);
    border-radius: 8px;
    color: #fca5a5;
    font-size: 14px;
    
    .error-icon {
      font-size: 20px;
    }
    
    button {
      margin-left: auto;
      padding: 6px 16px;
      background: rgba(239, 68, 68, 0.2);
      border: 1px solid rgba(239, 68, 68, 0.4);
      border-radius: 6px;
      color: #ffffff;
      font-size: 13px;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:hover {
        background: rgba(239, 68, 68, 0.3);
      }
    }
  }
  
  .songs-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    
    &.side-by-side {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;
      
      @media (max-width: 1024px) {
        grid-template-columns: 1fr;
      }
    }
  }
  
  .songs-section {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 20px;
    
    .songs-content.side-by-side & {
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
    }
    
    .subsection-title {
      font-size: 18px;
      font-weight: 600;
      color: #ffffff;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      gap: 10px;
    }
    
    .badge-adding,
    .badge-removing {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      font-size: 16px;
      font-weight: bold;
      color: #ffffff;
      flex-shrink: 0;
    }
    
    .badge-adding {
      background: linear-gradient(135deg, #10b981 0%, #059669 100%);
      box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
    }
    
    .badge-removing {
      background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
      box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
    }
  }
  
  .playlists-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    
    &.side-by-side {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;
      
      @media (max-width: 1024px) {
        grid-template-columns: 1fr;
      }
    }
  }
  
  .playlists-section {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 20px;
    
    .playlists-content.side-by-side & {
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
    }
    
    .subsection-title {
      font-size: 18px;
      font-weight: 600;
      color: #ffffff;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      gap: 10px;
    }
    
    .badge-refresh,
    .badge-reset {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      font-size: 16px;
      flex-shrink: 0;
    }
    
    .badge-refresh {
      background: rgba(59, 130, 246, 0.2);
      box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
    }
    
    .badge-reset {
      background: rgba(168, 85, 247, 0.2);
      box-shadow: 0 2px 8px rgba(168, 85, 247, 0.2);
    }
  }
  
  .cards-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  
  /* Responsive */
  @media (max-width: 768px) {
    padding: 0 16px;
    
    .section-title {
      font-size: 22px;
    }
    
    .tab {
      font-size: 14px;
      padding: 10px 16px;
    }
    
    .songs-section,
    .playlists-section {
      padding: 16px;
    }
    
    .cards-grid {
      gap: 10px;
    }
  }
  
  @media (max-width: 480px) {
    .cards-grid {
      gap: 8px;
    }
  }
`;

